import "aos/dist/aos.css";
import mapboxStyles from "mapbox-gl/dist/mapbox-gl.css";
import swiperCore from "swiper/css";
import swiperPagination from "swiper/css/pagination";
import "./src/styles/global.scss";
if (mapboxStyles && swiperCore && swiperPagination)
  console.log("styles loaded");
